const mutations = {
    SET_ERROR_SUPPLIERS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
